import React from "react";
import { Link } from "react-router-dom";
import Rightimage from "../assets/images/Aboutus-img.svg";
import Leftimage from "../assets/images/Left-img.svg";
import Clients from "./Clients";

const ThemeParkDetailLanding: React.FC = () => {
  return (
    <section className="relative bg-white text-gray-800 py-16">
      <div className="absolute right-0 top-2 sm:top-0 w-16 sm:w-auto">
        <img src={Rightimage} alt="Seamless Travel" className="object-fill" />
      </div>

      <div className="max-w-4xl mx-auto px-6 space-y-14">
        <section>
       
          <p className="text-lg leading-relaxed text-gray-700 font-poppins">
            You want a magical family trip—but the thought of long lines,
            complicated ticketing systems, and endless walking with grumpy kids?
            Not exactly dreamy.
          </p>
        </section>
    

        <section>
          <h2 className="text-2xl font-semibold text-blue-800 mb-3 font-akshar">
            The Magic
          </h2>
          <p className="text-lg leading-relaxed text-gray-700 font-poppins">
            Imagine the joy on their faces as they meet Elsa. The thrill of
            riding through Hogwarts. Perfectly timed character breakfasts,
            front-row seats for the parade, and not a moment of frustration in
            sight.
          </p>
        </section>
      </div>
      <div className="absolute left-0 bottom-2 sm:bottom-0 w-16 sm:w-36">
        <img src={Leftimage} alt="Seamless Travel" className="object-fill" />
      </div>
    </section>
  );
};

export default ThemeParkDetailLanding;
